module.exports = __webpack_public_path__ + "components/MapControl/svg/Targowisko.svg?af542263";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Targowisko.svg
// module id = 2080
// module chunks = 0